/**
 * 서버가 있기 전까지 프라이빗 토큰을 보유한 사용자만 보여지는 필터 작업
 * emptyPrivateAddress, privateTokenList 차이
 * - emptyPrivateAddress: 사용자가 지갑을 연결 하지 않았을 때 private 풀을 안보이게 처리
 * - privateTokenList: 사용자가 해당 토큰을 가지고 있을 경우 배열에 포함시키지 않음
 * - Pools.tsx에서 배열이 포함 되어 있지 않는 것만 화면에 보여줌
 * - POLYGON_PRIVATE_TOKEN${number}_CONTRACT_ADDRESS 테스트 컨트랙트 -> 프라이빗 바뀔 때마다 추가
 */

import {
  COIN_NAME_PRIVATE_TOKEN1,
  METHODS_BALANCE_OF,
  POLYGON_PRIVATE_TOKEN1_CONTRACT_ADDRESS,
  POLYGON_PRIVATE_TOKEN2_CONTRACT_ADDRESS,
} from '../common/name-space';
import { ContractBalanceOf } from '@/types';
import BigNumber from 'bignumber.js';
import {
  CheckPrivateToken,
  PrivateTokenTypeWithSymbol,
} from '@/types/private-token/private-token-type';

/**
 * 지갑 미연동, 일반 회원은 프라이빗 컨트랙트을 볼 수 없다.
 *
 */
// 지갑 미연동 일 때
// export const emptyPrivateAddress = (): string[] => {
//   const arrDelete = [];
//   arrDelete.push(POLYGON_PRIVATE_TOKEN1_CONTRACT_ADDRESS);
//   // arrDelete.push(POLYGON_PRIVATE_TOKEN2_CONTRACT_ADDRESS)
//   return arrDelete;
// };
// // 프라이빗 코인이 있을 경우 제외 배열에 포함하지 않는데
// export const privateTokenList = async (aPayload: PrivateTokenType): Promise<string[]> => {
//   const { web3authCall, address } = aPayload;
//   const networks: resNetworkList[] = networkList();
//   const arrDelete = [];
//   for (const iter of networks) {
//     // 기반코인
//     if (!iter.token) {
//       continue;
//     }
//     // sfl, tri
//     if (iter.symbol === COIN_NAME_TRI || iter.symbol === COIN_NAME_SFL) {
//       continue;
//     }
//     const payload = {
//       web3authCall,
//       symbol: iter.symbol,
//       address,
//     };
//     const { isOwn } = await isPrivateToken(payload);
//     if (isOwn) {
//       continue;
//     }
//     // const bal = await web3authCall!.getRpc().getTokenBalance(payload);
//     // // 프라이빗 코인이 존재
//     // if (!BigNumber(bal).isZero()) {
//     //   continue;
//     // }

//     switch (iter.symbol) {
//       case COIN_NAME_PRIVATE_TOKEN1:
//         arrDelete.push(POLYGON_PRIVATE_TOKEN1_CONTRACT_ADDRESS);
//         break;
//       case COIN_NAME_PRIVATE_TEST2:
//         arrDelete.push(POLYGON_PRIVATE_TOKEN2_CONTRACT_ADDRESS);
//         break;

//       default:
//         break;
//     }
//   }
//   return arrDelete;
// };
/**
 * 	  일반회원 	  일반회원	  특수회원	  특수 회원   특수 회원
	    일반 풀	    특수 풀	   일반 풀	   특수 풀     다른 특수 풀
isOwn	TRUE	     FALSE	   TRUE       TRUE       FALSE

 * 특수 회원은 모든 특수 풀에 접근 할 수 없고 특정 컨트랙트만 접근 가능하다
 * @param aPayload: {web3authCall: Web3AuthCall, address: string, contract: string;}
 * @returns isOwn: boolean
 */
export const isCheckPrivateToken = async (aPayload: CheckPrivateToken): Promise<boolean> => {
  const { web3authCall, address, contract } = aPayload;
  const symbol = privateTokenSymbolByContract(contract);
  let isOwn = false;
  if (!symbol) {
    return (isOwn = true);
  }
  const payload: PrivateTokenTypeWithSymbol = {
    web3authCall,
    address,
    symbol,
  };
  const re = await isPrivateToken(payload);
  isOwn = re.isOwn;
  return isOwn;
};

// 프라이빗 풀 컨트랙트(토큰 컨트랙트가 아님)
export const privateTokenSymbolByContract = (aContract: string): string | null => {
  let symbol = null;
  switch (aContract) {
    case POLYGON_PRIVATE_TOKEN1_CONTRACT_ADDRESS:
    case POLYGON_PRIVATE_TOKEN2_CONTRACT_ADDRESS:
      symbol = COIN_NAME_PRIVATE_TOKEN1;
      break;
    // Facebook Mission Pool
    case '0x61ae3B1ff09538E9F3a1Add7cF5C6AFf91DF996C':
      symbol = 'AIR1';
      break;
    // X Mission Pool
    case '0x36ada199d59b126734411F60300E28fe3BAA640d':
      symbol = 'AIR2';
      break;
    // TikTok Mission Pool
    case '0xeBB5fb0e85703F477Cd4f67aEf7c4998A769F6D7':
      symbol = 'AIR3';
      break;
    case '0x334F2235b0023Fd995CDbA6c8598B6c1093be3F7':
      symbol = 'CTF1';
      break;
    case '0x103870A03Da0F6EeED216b98d29201Fc212D7747':
    case '0x1E8a60bf47916fF46Dca4cA68C7Cf60a17905535':
    case '0x5394dB230eAE51566B5590fD88053D20FC5E9F69':
    case '0xC4C176DAA1DEAd07831D567eF716e99c62611a49':
      symbol = 'test';
      break;
    default:
      break;
  }
  return symbol;
};

export const isPrivateToken = async (aPayload: PrivateTokenTypeWithSymbol) => {
  const { web3authCall, symbol, address } = aPayload;
  const payload: ContractBalanceOf = {
    method: METHODS_BALANCE_OF,
    symbol: symbol,
    address: address,
  };
  const bal = await web3authCall!.getRpc().getTokenBalance(payload);
  let isOwn = false;
  if (!BigNumber(bal).isZero()) {
    isOwn = true;
  }
  return { isOwn, bal };
};
